<template>
    <div>
         <card>
             <b-form-group
                :label="$t('air_pollution_limits.type_selection')" >
                <b-form-select class="number" id="airPollutionTypeSelect" v-model="airPollutionLimitType" :options="airPollutionLimitTypeValues"></b-form-select>
             </b-form-group>

             <b-form-group
                :label="$t('air_pollution_limits.air_pollution_limits')">
                <div class="table">
                    <div v-for="(item,index) in airPollutionLimits" :key="index">
                        <div class="row">
                            <div class="cell airName">{{ item.name }} </div>
                            <div class="cell">PM10</div>
                            <div class="cell">min<b-form-input v-model="item.pm10.min" step="0.1" type=number class="number" size="sm"  ></b-form-input></div>
                            <div class="cell">max<b-form-input v-model="item.pm10.max" type=number class="number" size="sm"></b-form-input> </div>
                        </div>
                        <div class="row">
                            <div class="cell airName"></div>
                            <div class="cell">PM2.5</div>
                            <div class="cell">min<b-form-input v-model="item.pm2_5.min" type=number class="number" size="sm"></b-form-input></div>
                            <div class="cell">max<b-form-input v-model="item.pm2_5.max" type=number class="number" size="sm"></b-form-input> </div>
                        </div>
                    </div>
                </div>
             </b-form-group>
            <FormButtons
            @submit="submit"
            :reset="false" 
            :remove="false"
            :itemid="item.id"
            :disableSubmit="disableSubmit" 
            @remove="remove">
        </FormButtons>
        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
         </card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            airPollutionLimits: [],
            airPollutionLimitType: "",
            airPollutionLimitTypeValues: [ 
                { value:"pm10",text:"PM10" } , 
                { value:"pm2_5", text:"PM2.5"} ],
            item: {
                id:"1"
            },
            disableSubmit:false,
            noWheel:false,
            loading: false,
            ok: false,
            error: false,
            infoType: "save"
        }
    },
    created() {
        this.$traveller_http.get('/traveller/restui/device/general/getDeviceParametersByContext?context=airPollution')
            .then( response => {
                var limitsSet = false
                response.data.forEach(item => {
                    if( !limitsSet && item.name == 'air_pollution_limits') {
                        this.airPollutionLimits = item.value
                    }
                    if( item.name == 'air_pollution_limit_type') {
                        this.airPollutionLimitType = item.value
                    } 
                })
            })
        
    },
    methods: {
        submit() {
            var data = { 
                "name":"air_pollution_limits",
                "device_type": "SSE_DISPLAY",
                "context": "airPollution",
                value : this.airPollutionLimits
             }
             this.saveGlobalParameter(data)
             var data2 = JSON.parse( JSON.stringify(data) )
             data2.name="air_pollution_limit_type"
             data2.value=this.airPollutionLimitType
             this.saveGlobalParameter(data2)
             
        },
        remove() {
            //console.log("Remove");
        },
        saveGlobalParameter( data ) {
            this.ok = this.error = false;
             this.infoType = "save";
             this.loading = true;
             this.$traveller_http.post('/traveller/restui/device/general/saveGlobalDeviceParameter' , data )
                .then( response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok
                })
                .catch( () => { this.error = true })
                .finally( () => {
                    this.loading = false;
                })
        }
    }
}
</script>

<style scoped lang="scss">
.number {
   width: 7em;
}

.airName {
    font-weight: bold;
    width: 10em;
}
.table {
    display:table;
}
.row {
    display: table-row;
}
.cell {
    display: table-cell;
    padding:0.5em;
}


</style>

